'use strict';

var format = require('string-format');
var tuneInRequest = require('../tuneInRequest');

module.exports = function tuneService(config, apiContext, applyReauth) {
  var tuneEndpoint = format('{opml}/Tune.ashx', config.domains);
  var proxyEndpoint = format('{local}/proxy/tune', config.domains);
  var streamUnwrapEndpoint = format('{stream}/listen.stream', config.domains);

  function load(params) {
    return tuneInRequest({
      method: 'get',
      url: tuneEndpoint,
      params: params
    }, apiContext);
  }

  function proxyLoad(params) {
    return tuneInRequest({
      method: 'get',
      url: proxyEndpoint,
      params: params
    }, apiContext);
  }

  function streamUnwrap(params) {
    return tuneInRequest({
      method: 'get',
      url: streamUnwrapEndpoint,
      params: params
    }, apiContext);
  }

  return {
    load: applyReauth(load),
    proxyLoad: applyReauth(proxyLoad),
    streamUnwrap: applyReauth(streamUnwrap)
  };
};
//# sourceMappingURL=tune.js.map